import { fetchThemeData } from '../actions/routines';
import { call, put } from 'redux-saga/effects';
import Products from '../services/api/Products';

export function* fetchThemeSaga(action) {
    try {
        console.log('action payload', action);
        yield put(fetchThemeData.request());

        const response = yield call(Products.getTheme, action.payload);

        yield put(fetchThemeData.success(response.data));
    } catch (error) {
        yield put(fetchThemeData.failure(error.message));
    } finally {
        yield put(fetchThemeData.fulfill());
    }
}
